import { Var, Entity } from "../lib/stores/firestore";
import { Place } from "./place";

@Entity({ collection: "menus" })
export class Menu {
    @Var(Place)
    place: Place | null = null;
}
